import React,{ useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import CreditCardPaymentFields from './CreditCardPaymentFields'
import { SubscriptionsInputs } from '../../pages/types'
import useLists from '../../hooks/useLists';
import { numberWithCommas, ISOStringToDateFormatStbDate, expiryFormat } from '../../lib/utils'
import { PaymentFieldsetProps, PaymentInput } from './PaymentInfoFieldset';
import useSubscribers from '../../hooks/useSubscribers';
import { getCustomerUid } from '../../lib/api/subscriber';
import { callEasyPaymentsBodyTypes } from '../../pages/Subscriptions';
import querystring from 'query-string'

function PaymentStatusFieldSet(props:PaymentFieldsetProps){
  const { listId, errorCode } = props
  const [ isShow, setIsShow ] = useState(false);
  const { listsInfo } = useLists()
  const { subscribersInfo, updateSubscriber } = useSubscribers()
  const { payment, paymentMethod, status } = subscribersInfo.data

  //select paid, nonpaid
  const [ selectPaidSubscription, setSelectPaidSubscription ] = useState<string>('N')
  const handleRadioChange = (e:React.ChangeEvent<HTMLInputElement>) => setSelectPaidSubscription(e.target.value)

  //select payments method
  const [ paymentOption, setPaymentOption ] = useState<string>('')
  const handlePaymentsRadioChange = (e:React.ChangeEvent<HTMLInputElement>) => setPaymentOption(e.target.value)

  //failure control
  const [ result, setResult ] = useState('')
  const [ errorMsg, setErrorMsg ] = useState('')

  useEffect(()=>{
    if(subscribersInfo.status === 'success'){
      if(status === 'S' && payment.currentItemCode === 1){
        //유료구독
        setSelectPaidSubscription('Y')
      }else if(status === 'S' && payment.currentItemCode === 0 && payment.nextItemCode === 0){
        //무료구독
        setSelectPaidSubscription('N')
      }else if(status === 'R'){
        //구독대기
        setSelectPaidSubscription('')
      }
      setIsShow(false)
    }else if(subscribersInfo.status === 'failure'){
      setResult('show')
      //에러 코드에 따른 메세지 분기
      if(subscribersInfo.errorData?.response?.data.Code === 'Errors.Payment.InvalidPaymentInformation') {
        setErrorMsg('잘못된 결제 정보입니다.')
      }else if(subscribersInfo.errorData?.response?.data.Code === 'Errors.Payment.FailedToPay'){
        setErrorMsg('결제에 실패했습니다.')
      }else{
        setErrorMsg(subscribersInfo.errorData?.response?.data.Message)
        // setErrorMsg('관리자에게 문의..')
      }
    }
    //무료 구독일 때 카카오페이로 결제 실패
    if(errorCode && status === 'S' && payment.currentItemCode === 0 && payment.nextItemCode === 0){
      if(errorCode === 'Errors.List.NotExistEmail' 
      ||errorCode === 'Errors.Payment.NoPaymentMethod' 
      ||errorCode === 'Errors.Payment.NoSuchSubscriptionItem' 
      ||errorCode === 'Errors.List.NotExistList' 
      ||errorCode === 'Errors.Payment.FailedToPay'
      ){
        setIsShow(true)
        setSelectPaidSubscription('Y')
        setPaymentOption('KAKAOPAY')
        setResult('show')
        setErrorMsg('결제에 실패했습니다.')
      }
    } 
  },[subscribersInfo, payment])

  //기본 버튼 
  const handleClickUpdateShowBtn = () =>{
    setIsShow(!isShow)
  }

  const onClickCancelButton = (e:React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    setResult('')
    setIsShow(!isShow)
  }

  const closePaymentError = () =>{
    setResult('')
    clearErrors()
  }

  //form control
  const { register, handleSubmit, errors, setValue, clearErrors } = useForm<SubscriptionsInputs>()
  
  //해지 취소
  const onClickReSubscribe = () =>{
    const updateSubscriberBody = {
      listId: listId,
      subscriber: subscribersInfo.data.email,
    }
    const requestBody = {
      subscriber:{"$subscription_item_code":1}
    }
    
    updateSubscriber({...updateSubscriberBody, requestBody})
  }

  //저장, 결제
  const onCLickSaveButton = () =>{
    const updateSubscriberBody = {
      listId: listId,
      subscriber: subscribersInfo.data.email,
    }
    const requestBody = {
      subscriber:{"$subscription_item_code":selectPaidSubscription === 'Y'?1:0}
    }
    updateSubscriber({...updateSubscriberBody, requestBody})
  }

  //input창 분기
  const subscriptionStatus = () =>{
    if(status === 'S' && payment.currentItemCode === 0 && payment.nextItemCode === 0){
      return (
        <>
          <p>무료 구독</p>
        </>
      )
    }else if(status === 'S' && payment.currentItemCode === 1 && payment.nextItemCode === 1){
      return (
        <>
          <p>유료 구독<span className='subscription_price'>월 {numberWithCommas(String(payment.payingPrice))}원</span></p>
          {paymentMethod.cardNumber && 
            <p className='payment_next'>
              다음 결제일은 {ISOStringToDateFormatStbDate(payment.renewalDate)}입니다.
            </p>
          }
        </>
      )
    }else if(status === 'S' && payment.currentItemCode === 1 && payment.nextItemCode === 0){
      return(
        <>
        <p>유료 구독<span className='subscription_price'>월 {numberWithCommas(String(payment.payingPrice))}원</span></p>
        <div className='cancel_subscribe'>
          <span>{ISOStringToDateFormatStbDate(payment.renewalDate)}에 유료 구독이 해지될 예정입니다.</span>
          <span className='resubscribe' onClick={onClickReSubscribe}>해지 취소하기</span>
        </div>
        </>
      )
    }else if(status === 'D'){
      return (
        <>
          <p>수신거부</p>
        </>
      )
    }else if(status === 'R'){
      return (
        <>
          <p>구독 대기</p>
        </>
      )
    }
  }

  //
  const onSubmit = (data:PaymentInput) =>{
    const updateSubscriberBody = {
      listId: listId,
      subscriber: subscribersInfo.data.email,
    }
    let paymentBody = {
      subscriber:{"$subscription_item_code":1}, 
    }
    if(paymentOption === 'CREDITCARD'){
      paymentBody = Object.assign(paymentBody,{
        paymentInformation:{
          cardNumber:data.cardNumber.replace(/ /g,'-'),
          expiry:expiryFormat(data.expiry),
          password2Digits:data.password2Digit,
          birth:data.birth
        },
        paymentType: 'creditcard'
        }
      )
      updateSubscriber({...updateSubscriberBody, requestBody:paymentBody})

    }else if(paymentOption === 'KAKAOPAY'){
      paymentBody = Object.assign(paymentBody, 
        {paymentType: 'kakaopay'},
      )
      getCustomerUid({...updateSubscriberBody, requestBody:{"paymentType":"kakaopay", "itemCode":1}}).then((res)=>{
        const { customerUid, merchantUid, buyerEmail, buyerName, buyerTel } = res.data
        const easyPaymentsBody:callEasyPaymentsBodyTypes = {
          paymentType:paymentOption,
          buyerEmail:buyerEmail,
          buyerName:buyerName,
          buyerTel:buyerTel,
          customerUid:customerUid,
          merchantUid:merchantUid
        }
        callEasyPayments(easyPaymentsBody, process.env.REACT_APP_API_URI)
      })
    }else if(paymentOption === 'NAVERPAY'){
      console.log('NAVERPAY')
      console.log(window.Naver)
      paymentBody = Object.assign(paymentBody, 
        {paymentType: 'naverpay'},
      )
    }
      // const paymentBody = {
    //   subscriber:{"$subscription_item_code":1}, 
    //   paymentInformation:{
    //     cardNumber:data.cardNumber.replace(/ /g,'-'),
    //     expiry:expiryFormat(data.expiry),
    //     password2Digits:data.password2Digit,
    //     birth:data.birth
    //   }
    // }  
    // const paymentBody = {
    //   subscriber:{"$subscription_item_code":1}, 
    //   paymentInformation:{
    //     cardNumber:data.cardNumber.replace(/ /g,'-'),
    //     expiry:expiryFormat(data.expiry),
    //     password2Digits:data.password2Digit,
    //     birth:data.birth
    //   }
    // }

    // updateSubscriber({...updateSubscriberBody, requestBody:paymentBody})

    clearErrors()

  }

  function callEasyPayments(data:callEasyPaymentsBodyTypes, redirectUrl?:string) {
    const { paymentType, customerUid, merchantUid, buyerEmail, buyerName, buyerTel } = data
    /* 1. 가맹점 식별하기 */
    const { IMP } = window;
    IMP.init('imp27287957');

    switch(paymentType){
      case 'KAKAOPAY':
        const data = {
          pg:'kakaopay',
          merchant_uid : merchantUid,
          name : listsInfo.data.listName + ' 최초인증결제',
          amount : 0, // 빌링키 발급만 진행하며 결제승인을 하지 않습니다.
          customer_uid : customerUid, //customer_uid 파라메터가 있어야 빌링키 발급이 정상적으로 이뤄집니다.
          buyer_email : buyerEmail,
          buyer_name : buyerName,
          buyer_tel : buyerTel,
          m_redirect_url :`${redirectUrl}/lists/${listId}/payment/kakao`
        }
        
        IMP.request_pay(data, 
          function(rsp) {
            if ( rsp.success ) {
              const data = {
                imp_success: rsp.imp_success,
                imp_uid : rsp.imp_uid,
                merchant_uid : rsp.merchant_uid
                //기타 필요한 데이터가 있으면 추가 전달
              }
              const qsSuccess = querystring.stringify(data)
            //테스트 용. 추후 history.push 방식으로 변경
            // alert('빌링키 발급 성공');
            window.location.href = `${redirectUrl}/lists/${listId}/payment/kakao?`+qsSuccess;
              
          } else if( !rsp.success ){
            const data = {
              imp_success: rsp.imp_success,
              imp_uid : rsp.imp_uid,
              merchant_uid : rsp.merchant_uid,
              error_msg: rsp.error_msg
              //기타 필요한 데이터가 있으면 추가 전달
            }
            const qsFailed = querystring.stringify(data)
            window.location.href = `${redirectUrl}/lists/${listId}/payment/kakao?`+qsFailed;
            // alert('빌링키 발급 실패 '+ qsFailed);
          }
        }
        );
      break;
    }
  }

  return(
    <div className="stb_form_set field">
      <label className="stb_subscriber_info_label">구독 유형</label><br/>
      {isShow?
        <>
          <div className="stb_subscription_state">
            <label className={`container ${selectPaidSubscription === 'Y'?'selected':''}`}>
              <div>
                <input
                  type='radio'
                  checked={selectPaidSubscription === 'Y'}
                  onChange={handleRadioChange}
                  value='Y'
                />
                <span className='radiomark'/>
                유료 구독 
              </div>
              <span className='subscription_price'>월 {numberWithCommas(listsInfo.data.paidSubscriptionItems[1].price)}원</span>
            </label>
            <label className={`container ${selectPaidSubscription === 'N'?'selected':''}`}>
              <input 
                type='radio'
                checked={selectPaidSubscription === 'N'}
                onChange={handleRadioChange}
                value='N'
                />
                <span className='radiomark'/>
              무료 구독
            </label>
          </div>
          
          {selectPaidSubscription === 'Y' && payment.currentItemCode !== 1?
            <>
              <form onSubmit={handleSubmit(onSubmit)}>

                <label className="stb_subscriber_info_label">결제 수단</label>
                <div className="payment_options">
                  <label className={`container ${paymentOption==='CREDITCARD'?'selected':''}`}>
                    <input 
                      type='radio'
                      checked={paymentOption==='CREDITCARD'}
                      onChange={handlePaymentsRadioChange}
                      value='CREDITCARD'
                      />
                    카드 결제
                  </label>
                  {/* <label className={`container ${paymentOption==='NAVERPAY'?'selected':''}`}>
                    <input 
                      type='radio'
                      checked={paymentOption==='NAVERPAY'}
                      onChange={handlePaymentsRadioChange}
                      value='NAVERPAY'
                    />
                    <span className='icon_naver_pay'/>
                  </label> */}
                  <label className={`container ${paymentOption==='KAKAOPAY'?'selected':''}`}>
                    <input 
                      type='radio'
                      checked={paymentOption==='KAKAOPAY'}
                      onChange={handlePaymentsRadioChange}
                      value='KAKAOPAY'
                    />
                    <span className='icon_kakao_pay'/>
                  </label>
                </div>
                {paymentOption === 'CREDITCARD' &&
                  <div className='container payment'>
                    <CreditCardPaymentFields register={register} errors={errors} setValue={setValue} clearError={clearErrors}/>
                  </div>
                }
                {/* <PaymentFields register={register} errors={errors} setValue={setValue} clearError={clearErrors}/> */}
                {(subscribersInfo.error || errorCode) &&
                  <div className={`payment_error ${result}`}>
                    <div className='payment_error_msg'>{errorMsg}</div>
                    <span className='payment_error_close' onClick={closePaymentError}/>
                  </div>
                }
                <button type="submit" className={`stb_form_submit_button btn secondary ${subscribersInfo.loading?'disable':''}`}>결제하기</button>
                <button className="stb_form_submit_button btn white" onClick={(e)=>onClickCancelButton(e)}>취소</button>
              </form>
              <div className="desc">
                <a href="https://stibee.com" rel="noopener noreferrer" target="_blank">스티비</a>가 결제를 대행합니다.&nbsp;
                <a href="https://www.notion.so/stibee/cf6feb7107784a20b3bae4d0646790e0" rel="noopener noreferrer" target="_blank">이용약관</a>&nbsp;
                <a href="https://www.notion.so/stibee/8ccec3806eba4107a474174399eebd90" rel="noopener noreferrer" target="_blank">개인정보처리방침</a>
              </div>
              
            </>
            :
            <>
              <button type="submit" className={`stb_form_submit_button btn secondary ${subscribersInfo.loading?'disable':''}`} onClick={onCLickSaveButton}>저장하기</button>
              <button className="stb_form_submit_button btn white" onClick={(e)=>onClickCancelButton(e)}>취소</button>
            </>
            }
          
        </>
        :
        <>
          {!(status === 'S' && payment.currentItemCode === 1 && payment.nextItemCode === 0) &&
            <span className="update_show_btn" onClick={handleClickUpdateShowBtn}>변경하기</span>
          }
          {subscriptionStatus()}
        </>
      }
    </div>
  )
}

export default PaymentStatusFieldSet